import { z } from 'zod';
import { SSN_LAST4_PATTERN } from './masking.js';
import { revealPurposeSchema, sensitiveFieldSchema } from './vocabulary.js';
/**
 * What the ADR-012 §1 and §4 endpoints hand back. Here rather than beside the handlers, because
 * this is the one module allowed to name these fields (`check:sensitive-fields`), and because the
 * client parses responses with the schema the API validated against (CLAUDE.md rule 3).
 */
/**
 * `GET /api/people/{id}/sensitive` — WHAT IS ON FILE, never what it is.
 *
 * `ssnLast4` is the only part of either value that crosses without a reveal, and the date of birth
 * has no equivalent: four digits identify a person far less than a birth date does, so the date is
 * a boolean and nothing more.
 */
export const sensitiveOnFileSchema = z
    .object({
    ssnOnFile: z.boolean(),
    ssnLast4: z.string().regex(SSN_LAST4_PATTERN).nullable(),
    dateOfBirthOnFile: z.boolean(),
})
    .strict()
    .superRefine((value, ctx) => {
    // The two must agree, or the UI masks a number it does not have — or worse, shows four digits
    // for a person whose record holds none.
    if (value.ssnOnFile !== (value.ssnLast4 !== null)) {
        ctx.addIssue({ code: z.ZodIssueCode.custom, path: ['ssnLast4'], message: 'ssnLast4 is present exactly when an SSN is on file' });
    }
});
/** `POST /api/people/{id}/sensitive/reveal` — the one response that carries a value. */
export const sensitiveRevealRequestSchema = z
    .object({ field: sensitiveFieldSchema, purpose: revealPurposeSchema })
    .strict();
export const sensitiveRevealResponseSchema = z
    .object({ field: sensitiveFieldSchema, value: z.string().min(1) })
    .strict();
/**
 * `PUT /api/people/{id}/sensitive`. Absent means leave alone; `null` means remove.
 *
 * THERE IS NO REASON FIELD, and its absence is deliberate. ADR-012 §1 says HR corrects "with a
 * reason", but §5 specifies the audit row as field names plus actor and `checkSensitiveAuditRow`
 * refuses ALL free text on a sensitive row — because free text is where somebody types the
 * number. A reason box that reached nothing would be worse than none. Raised on #369.
 */
export const sensitiveUpdateSchema = z
    .object({
    ssn: z.string().nullable().optional(),
    dateOfBirth: z.string().date().nullable().optional(),
})
    .strict();
//# sourceMappingURL=api.js.map